import { getRequest } from "../apiRequest";
import { apiRoutes } from "../Constants/ApiRoutes";

export const getCategory = async (pathParams) => {
  const response = await getRequest(apiRoutes.categories, {
    limit: 500,
    sortBy: "rank",
    sort: "DESC",
  }, pathParams);

  return response?.data?.data.categories
};

export const getAllCategories = async (pathParams) => {
  const response = await getRequest(apiRoutes.allCategories, null, pathParams);
  return response?.data?.data.categories
};

export const getCategoryBySlug = async ( { categorySlug } ) => {
  const path = apiRoutes.categoryBySlug.replace(":categorySlug", categorySlug);
  const response = await getRequest(path);
  return response?.data?.data.categoryDetails
}

export const getSubcategories = async ({categorySlug}) => {
  const path = apiRoutes.subCategories.replace(":categorySlug", categorySlug);
  const response = await getRequest(path);
  const subCategories = response?.data?.data?.categories ?? [];
  return subCategories;
}
